import { isEmpty, isNumber, pickBy } from 'lodash';
import { parseDate } from 'helpers';

export default (params) => {
  params = pickBy(
    params,
    (v) => !isEmpty(v) || isNumber(v) || v instanceof Date || typeof v === 'boolean',
  );

  Object.keys(params).forEach((key) => {
    if (params[key] instanceof Date) {
      params[key] = parseDate(params[key], 'YYYY-MM-DD HH:mm:ss');
    }
    if (typeof params[key] === 'boolean') {
      params[key] = params[key] ? 1 : 0;
    }
  });

  return params;
};
